import React from "react"
import Container from '@material-ui/core/Container'
import { Backdrop, CircularProgress } from "@material-ui/core"

import { SnackbarCustom } from "../Utilities/SnackbarCustom";

import Typography from '@material-ui/core/Typography'

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import { OutboxProduct } from "./sections/product/OutboxProduct"
import { OutboxDraft } from "./sections/draft/OutboxDraft"
import { OutboxAddress } from "./sections/address/OutboxAddress"
import { OutboxFeatures } from "./sections/features/OutboxFeatures"
import { OutboxSummary } from "./sections/summary/OutboxSummary"
import { OutboxConfirmShipment } from "./sections/summary/OutboxConfirmShipment"

import AuthCli from "../../sdk/AuthCli";
import OutboxCli from "../../sdk/OutboxCli"
import UserCli from "../../sdk/UserCli"
import ProductCli from "../../sdk/ProductCli"
import BillableCli from "../../sdk/BillableCli"

import { localizer } from "../../Translator"
import OutboxShipmentSummary from "./sections/summary/OutboxShipmentSummary"
import DateCustom from "../Utilities/DateCustom"
import Roles from "../Utilities/Roles"

const FIRST_STEP = 1
const LAST_STEP = 6

/**
 * Screen for shipment emission. This is the top level layout including the different
 * steps the user must complete in order to eventually emit or save a new shipment or
 * make modifications to a previous one.
 */
export class ShipmentsLayout extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      // Waiting for server response indicator.
      isLoading: false,

      // Indicates the panel (sub-screen) that is currently visible, ie. the step the user is editing.
      step: 1,
      actionAfterConfirm: "",

      // Current billable which user in session belong to
      billable: null,

      // All the information the user is entering from the different steps, to be the data structure
      // sent to the outbox service when the shipment/s are eventually saved.
      shipments: [],

      initialshipment: {
        shipmentId: null,
        shipmentCode: null,
        saveTime: null,
        emissionTime: null,
        dequeuedTime: null,
        pages: [],
        destinationAddress: {
          who: "",
          contact: "",
          phone: "",
          identityCard: "",
          countryIso: "",
          locality: "",
          postalCode: "",
          streetType: "",
          streetName: "",
          streetNumber: "",
          streetComplements: "",
          envelopeBox: []
        },
        senderAddress: {
          who: "",
          contact: "",
          phone: "",
          identityCard: "",
          countryIso: "",
          locality: "",
          postalCode: "",
          streetType: "",
          streetName: "",
          streetNumber: "",
          streetComplements: "",
          envelopeBox: []
        },
        features: {
          productCode: null,
          printColor: null,
          printDuplex: null,
          reference: "",
          price: 100,
          notifyToThirdParty: null,
        },
        ownerUser: null
      },

      // List of products availables for the user in session
      products: [],

      // In case of recives a shipment, it will save the drafts that were selected on that shipment.
      draftsSelected: [],

      // Flag to indicate if the user is editig or resending a shipment. Then, some options need to be disabled.
      notNewShipment: false,

      // Success or error message on failure trying to load a shipment.
      shipmentCodeError: null,
      shipmentCodeErrorOpen: false,

      // Success or error message on failure trying to load a draft.
      loadDraftError: null,
      loadDraftErrorOpen: false,

      // Texts to display for every of the steps in the shipment emission process.
      // These literals are not constants because of language changes. Array to be
      // filled in when the language changes.
      stepLiterals: [],
    }
  }

  componentDidMount = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    const shipmentCode = queryParams.get('shipmentCode') !== null ? queryParams.get('shipmentCode') : queryParams.get('ShipmentCode') !== null ? queryParams.get('ShipmentCode') : null
    const draftCode = queryParams.get('draftCode') !== null ? queryParams.get('draftCode') : queryParams.get('DraftCode') !== null ? queryParams.get('DraftCode') : null

    let notNewShipment = shipmentCode || draftCode

    this.setState({ isLoading: true, notNewShipment: notNewShipment })

    await this.getSessionInfo()
    this.getPasswordExpiration()

    // Initializing product list
    await this.getAvailableProductsForUser()

    // Initiaziling the shipment list adding the initial shipment for the firsts steps
    await this.getDefaultUserPostalAddress()
    await this.getCurrentBillable()

    if (shipmentCode) {
      this.getShipmentFromUrl(shipmentCode)
      this.setState({ isLoading: false })
      return
    }
    
    if (draftCode) {
      this.initializeShipmentByDraft(draftCode)
      this.setState({ isLoading: false })
      return
    }

    let currentDate = new Date()

    this.setState(previousState => ({
      initialshipment: {
        ...previousState.initialshipment,
        emissionTime: currentDate
      }
    }), () => {
      this.setState({ shipments: [...this.state.shipments, this.state.initialshipment], isLoading: false }, () => { this.fillStepLiterals() })
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps === this.props) return

    this.fillStepLiterals()
  }

  getSessionInfo = async () => {
    await AuthCli.GetSessionInfo().then(session => {
      if (session) {
        this.setState({ session: session })
      }
    })
  }

  // Check after successfully login if the password is close to expirate
  getPasswordExpiration = () => {
    AuthCli.GetPasswordExpiration().then(response => {
      if (response !== null) this.props.handlePasswordExpirationDate(response)
    })
  }

  // Getting list of product to visualize product description instead of productCode
  getAvailableProductsForUser = async () => {
    await ProductCli.GetAvailableProductsForUser().then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ productError: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ products: response })
      }
    })
  }

  // Getting shipment by shipmentCode query param and filling its drafts selected list
  getShipmentFromUrl = (shipmentCode) => {
    if (this.state.session.role === Roles.ROLE_USER.Name) {
      this.getShipmentByCode(shipmentCode)
      return
    }

    if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      this.getShipmentByCodeOfBillable(shipmentCode)
      return
    }
  }

  // Getting shipment by code for user with USER role
  getShipmentByCode = (shipmentCode) => {
    const queryParams = new URLSearchParams(window.location.search);

    OutboxCli.GetShipmentByCode(shipmentCode).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ shipmentCodeError: response.substring(response.indexOf(' ')) })
      } else {
        let draftList = []
        let shipment = response

        for (let index = 0; index < shipment.pages.length; index++) {
          let page = shipment.pages[index];
          
          OutboxCli.GetDraft(page.draftId).then(response => {
            if (response !== null && response.toString().startsWith("[ERR")) {
              this.setState({ loadDraftError: response.substring(response.indexOf(' ')) })
            } else {
              draftList.push(response)
            }
          })
        }

        const resend = queryParams.get('resend') !== null ? queryParams.get('resend') : null
        let step = 1
        // If the shipment is a resend, the shipmentId and shipmentCode must be null. Preparing the shipment to be sent again.
        // Otherwise, we check if the shipment is already sent and show the shipment summary.
        if (resend === "true") {
          shipment.shipmentId = null
          shipment.shipmentCode = null
          shipment.ownerUser = this.state.session.userEmail
          shipment.cancelTime = null
          shipment.cancelRequestedTime = null
          shipment.revisionDate = null

          let address = shipment.destinationAddress
          let streetType = (address.streetType !== null && address.streetType !== undefined) ? address.streetType.toString() : ""
          let streetNumber = (address.streetNumber !== null && address.streetNumber !== undefined) ? address.streetNumber.toString() : ""
          let streetName = (address.streetName !== null && address.streetName !== undefined) ? address.streetName.toString() : ""
          let streetComplements = (address.streetComplements !== null && address.streetComplements !== undefined) ? address.streetComplements.toString() : ""
          shipment.destinationAddress.streetName = (streetType + " " + streetName + " " + streetNumber + " " + streetComplements).trim()

          address = shipment.senderAddress
          streetType = (address.streetType !== null && address.streetType !== undefined) ? address.streetType.toString() : ""
          streetNumber = (address.streetNumber !== null && address.streetNumber !== undefined) ? address.streetNumber.toString() : ""
          streetName = (address.streetName !== null && address.streetName !== undefined) ? address.streetName.toString() : ""
          streetComplements = (address.streetComplements !== null && address.streetComplements !== undefined) ? address.streetComplements.toString() : ""
          shipment.senderAddress.streetName = (streetType + " " + streetName + " " + streetNumber + " " + streetComplements).trim()

        } else {
          // Shipment is already sent. Showing shipment summary
          if (shipment.emissionTime !== null && shipment.dequeuedTime !== null && (DateCustom.lowerThan(shipment.emissionTime, Date.now()))) {
            step = 99
          }
        }
        
        this.setState({ initialshipment: shipment, draftsSelected: draftList }, () => {
          this.setState({ shipments: [...this.state.shipments, this.state.initialshipment], step: step })
        })
      }
    })
  }

  // Getting shipment by code for user with ADMIN role
  getShipmentByCodeOfBillable = (shipmentCode) => {
    const queryParams = new URLSearchParams(window.location.search);

    OutboxCli.GetShipmentByCodeOfBillable(shipmentCode).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ shipmentCodeError: response.substring(response.indexOf(' ')) })
      } else {
        let draftList = []
        let shipment = response

        for (let index = 0; index < shipment.pages.length; index++) {
          let page = shipment.pages[index];
          
          OutboxCli.GetDraftOfBillable(page.draftId).then(response => {
            if (response !== null && response.toString().startsWith("[ERR")) {
              this.setState({ loadDraftError: response.substring(response.indexOf(' ')) })
            } else {
              draftList.push(response)
            }
          })
        }
        let step = 1
        const resend = queryParams.get('resend') !== null ? queryParams.get('resend') : null
        // If the shipment is a resend, the shipmentId and shipmentCode must be null. Preparing the shipment to be sent again.
        // Otherwise, we check if the shipment is already sent and show the shipment summary.
        if (resend === "true") {
          shipment.shipmentId = null
          shipment.shipmentCode = null
          shipment.ownerUser = this.state.session.userEmail
          shipment.cancelTime = null
          shipment.cancelRequestedTime = null
          shipment.revisionDate = null

          let address = shipment.destinationAddress
          let streetType = (address.streetType !== null && address.streetType !== undefined) ? address.streetType.toString() : ""
          let streetNumber = (address.streetNumber !== null && address.streetNumber !== undefined) ? address.streetNumber.toString() : ""
          let streetName = (address.streetName !== null && address.streetName !== undefined) ? address.streetName.toString() : ""
          let streetComplements = (address.streetComplements !== null && address.streetComplements !== undefined) ? address.streetComplements.toString() : ""
          shipment.destinationAddress.streetName = (streetType + " " + streetName + " " + streetNumber + " " + streetComplements).trim()

          address = shipment.senderAddress
          streetType = (address.streetType !== null && address.streetType !== undefined) ? address.streetType.toString() : ""
          streetNumber = (address.streetNumber !== null && address.streetNumber !== undefined) ? address.streetNumber.toString() : ""
          streetName = (address.streetName !== null && address.streetName !== undefined) ? address.streetName.toString() : ""
          streetComplements = (address.streetComplements !== null && address.streetComplements !== undefined) ? address.streetComplements.toString() : ""
          shipment.senderAddress.streetName = (streetType + " " + streetName + " " + streetNumber + " " + streetComplements).trim()

        } else {
          // Shipment is already sent. Showing shipment summary
          if (shipment.emissionTime !== null && shipment.dequeuedTime !== null && (DateCustom.lowerThan(shipment.emissionTime, Date.now()))) {
            step = 99
          }
        }
        
        this.setState({ initialshipment: shipment, draftsSelected: draftList }, () => {
          this.setState({ shipments: [...this.state.shipments, this.state.initialshipment], step: step })
        })
      }
    })
  }

  // Initializes a shipment based on a single draft.
  initializeShipmentByDraft = (draftCode) => {
    if (this.state.session.role === Roles.ROLE_USER.Name) {
      this.getDraft(draftCode)
      return
    }

    if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      this.getDraftOfBillable(draftCode)
      return
    }
  }

  // Getting draft by code for user with USER role
  getDraft = (draftCode) => {
    OutboxCli.GetDraft(draftCode).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ loadDraftError: response.substring(response.indexOf(' ')) })
      } else {
        let currentDate = new Date()
  
        this.setState(previousState => ({
          initialshipment: {
            ...previousState.initialshipment,
            emissionTime: currentDate
          },
          draftsSelected: [...previousState.draftsSelected, response]
        }), () => {
          this.setState({ shipments: [...this.state.shipments, this.state.initialshipment] })
        })
      }
    })
  }

  // Getting draft by code for user with ADMIN role
  getDraftOfBillable = (draftCode) => {
    OutboxCli.GetDraftOfBillable(draftCode).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ loadDraftError: response.substring(response.indexOf(' ')) })
      } else {
        let currentDate = new Date()
  
        this.setState(previousState => ({
          initialshipment: {
            ...previousState.initialshipment,
            emissionTime: currentDate
          },
          draftsSelected: [...previousState.draftsSelected, response]
        }), () => {
          this.setState({ shipments: [...this.state.shipments, this.state.initialshipment] })
        })
      }
    })
  }

  /**
   * Step literals are placed in the array of steps in the current language.
   */
  fillStepLiterals() {
    this.setState({
      stepLiterals: [localizer.ShipmentProgressStep1,
      localizer.ShipmentProgressStep2,
      localizer.ShipmentProgressStep3,
      localizer.ShipmentProgressStep4,
      localizer.ShipmentProgressStep5
      ]
    })
  }

  // Getting the default address user has set
  getDefaultUserPostalAddress = async () => {
    await UserCli.GetAddresses().then(async response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ postalAddressError: response.substring(response.indexOf(' ')) })
      } else {
        let postalAddresses = response

        await UserCli.GetSenderAddress().then(async response => {
          if (response !== null && response.toString().startsWith("[ERR")) {
            this.setState({ postalAddressError: response.substring(response.indexOf(' ')) })
          } else {
            var senderDefaultAddress = postalAddresses && postalAddresses.find(pa => pa.id === response)

            if (senderDefaultAddress) {
              this.setState(previousState => ({
                initialshipment: {
                  ...previousState.initialshipment,
                  senderAddress: senderDefaultAddress
                }
              }))
            }
          }
        })

      }
    })
  }

  // Filling billableId atributte getting it from the current session
  getCurrentBillable = async () => {
    await BillableCli.GetBillableOfSession().then(response => {
      if (response) {
        this.setState(previousState => ({
          initialshipment: {
            ...previousState.initialshipment,
            billableId: response.billableId
          },
          billable: response
        }))
      }
    })
  }

  calculateShipmentPrice = async (shipment) => {
    let totalPages = this.getTotalNumberPages(shipment)
    if (totalPages <= 0) return 0
    
    let priceDetails = null
    await ProductCli.CalculatePriceOfShipment(shipment.billableId,
      shipment.features.productCode,
      shipment.destinationAddress.countryIso,
      shipment.destinationAddress.postalCode,
      shipment.features.printColor,
      shipment.features.printDuplex,
      totalPages
    ).then(response => {
     
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ priceError: response.substring(response.indexOf(' ')) })
      } else {
        priceDetails = response
      }
    })
    return priceDetails
  }

  getTotalNumberPages = (shipment) => {
    if (!shipment) return 0
    if (!shipment.pages) return 0
    
    let totalPages = 0
    shipment.pages.forEach(p => {
      totalPages += p.pageLast - p.pageFirst + 1
    })

    return totalPages
  }

  /**
   * Based in the current step, the function return the component that must be rendered
   */
  getStep() {
    switch (this.state.step) {
      case 1:
        return <OutboxProduct handleOutboxState={this.handleOutboxState} shipments={this.state.shipments} calculateShipmentPrice={this.calculateShipmentPrice} products={this.state.products} />
      case 2:
        return <OutboxDraft handleOutboxState={this.handleOutboxState} shipments={this.state.shipments} draftsSelected={this.state.draftsSelected} notNewShipment={this.state.notNewShipment} />
      /*   case 3:
          return <OutboxPages handleOutboxState={this.handleOutboxState} shipments={this.state.shipments} draftsSelected={this.state.draftsSelected} /> */
      case 3:
        return <OutboxAddress handleOutboxState={this.handleOutboxState} shipments={this.state.shipments} draftsSelected={this.state.draftsSelected} billable={this.state.billable} notNewShipment={this.state.notNewShipment} products={this.state.products}/>
      case 4:
        return <OutboxFeatures handleOutboxState={this.handleOutboxState} shipments={this.state.shipments} draftsSelected={this.state.draftsSelected} billable={this.state.billable} calculateShipmentPrice={this.calculateShipmentPrice} products={this.state.products} />
      case 5:
        return <OutboxSummary handleOutboxState={this.handleOutboxState} shipments={this.state.shipments} draftsSelected={this.state.draftsSelected} products={this.state.products} notNewShipment={this.state.notNewShipment} />
      case 6:
        return <OutboxConfirmShipment shipments={this.state.shipments} action={this.state.actionAfterConfirm} notNewShipment={this.state.notNewShipment}></OutboxConfirmShipment>
      case 99:
        return <OutboxShipmentSummary shipmentCode={this.state.shipments.length > 0 ? this.state.shipments[0].shipmentCode : null} notNewShipment={this.state.notNewShipment}></OutboxShipmentSummary>
      default:
        return <React.Fragment />
    }
  }

  /**
   * Update the shipment state with the data received from child components.
   * Update the current step to render the next or previous component. 
   * @param obj Object received from child component to update parent component state
   * @param {int} currentStep Number of the step providing state update.
   * @param direction Indicate if the user pressed the next or previous button. Value 'next' means moving forward, otherwise backward.
   * @param action Indicate in the last step the user action did (STORE, SCHEDURE OR SEND).
   */
  handleOutboxState = (shipments, draftsselected, currentStep, direction, action) => {

    if (shipments) this.setState({ shipments: shipments })
    if (draftsselected) this.setState({ draftsSelected: draftsselected })
    if (action) this.setState({ actionAfterConfirm: action })

    // Make visible the next step panel the user has to see, moving forward or backward in the sequence of steps.
    if (direction === "next") {
      if (currentStep !== LAST_STEP) currentStep++
    } else {
      if (currentStep !== FIRST_STEP) currentStep--
    }
    this.setState({ step: currentStep })
  }

  handleonClose = () => {
    this.setState({ shipmentCodeError: null, loadDraftError: null })
  }
  
  render() {

    const STEPS = [
      localizer.ShipmentProgressStep1,
      localizer.ShipmentProgressStep2,
      /* localizer.ShipmentProgressStep3, */
      localizer.ShipmentProgressStep3,
      localizer.ShipmentProgressStep4,
      localizer.ShipmentProgressStep5
    ]

    return (
      <React.Fragment>
        <Container>

          {/* Top row with step indicators. */}
          <Stepper activeStep={(this.state.step - 1)} className="p-0 mt-10">
            {STEPS.map((description, index) => {
              return (
                <Step key={description} className="icon-size-custom" alternativeLabel>
                  <StepLabel><Typography className="typography-generic shipment-step">{description}</Typography></StepLabel>
                </Step>
              )
            })}
          </Stepper>

          {/* Content of the currently visible step panel. */}
          {this.getStep()}

        </Container>


        {/* Download draft error. */}
        <SnackbarCustom message={this.state.shipmentCodeError} severity="error" handleonClose={this.handleonClose} />
        
        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.loadDraftError} severity="error" handleonClose={this.handleonClose} />

        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/shipments/ShipmentsLayout.js